module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_calculator-64d726e01c6ec0072b0a7c6040688719.svg";